import React from "react";
import { MapPin, AlertTriangle } from "lucide-react";
import type { PackerBasePaint as BasePaintType } from "@/hooks/usePackers";

interface PackerBasePaintProps {
  basePaint: BasePaintType | null | undefined;
}

const PackerBasePaint = ({ basePaint }: PackerBasePaintProps) => {
  if (!basePaint) {
    return (
      <div className="bg-white/5 rounded-md p-2 mt-1 border border-white/10">
        <span className="text-white/40 text-xs">Geen match gevonden</span>
      </div>
    );
  }

  if (basePaint.ignored_brand) return null;

  const isOutOfStock = basePaint.is_out_of_stock || basePaint.voorraad <= 0;

  return (
    <div className={`rounded-md p-2 mt-1 border text-xs ${isOutOfStock ? 'bg-red-500/10 border-red-500/30' : 'bg-white/5 border-white/10'}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex-1 min-w-0">
          <span className="text-white/80 font-medium truncate block">
            {basePaint.product_naam}
          </span>
          {basePaint.eenheid && (
            <span className="text-white/40 ml-1">({basePaint.eenheid})</span>
          )}
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <span className="text-white/60 flex items-center gap-1">
            <MapPin className="w-3 h-3" />
            {basePaint.locatie}
          </span>
          <span className={`font-bold ${isOutOfStock ? 'text-red-400' : 'text-emerald-400'}`}>
            {basePaint.voorraad}
          </span>
          {basePaint.match_type && (
            <span className="bg-white/10 text-white/50 px-1.5 py-0.5 rounded text-[10px]">
              {basePaint.match_type}
            </span>
          )}
        </div>
      </div>
      {isOutOfStock && (
        <div className="flex items-center gap-1 text-red-400 mt-1">
          <AlertTriangle className="w-3 h-3" />
          <span>Niet op voorraad</span>
        </div>
      )}
    </div>
  );
};

export default PackerBasePaint;
